import { render, staticRenderFns } from "./ChannelManagement.vue?vue&type=template&id=5b8160ca&scoped=true&"
import script from "./ChannelManagement.vue?vue&type=script&lang=js&"
export * from "./ChannelManagement.vue?vue&type=script&lang=js&"
import style0 from "./ChannelManagement.vue?vue&type=style&index=0&id=5b8160ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8160ca",
  null
  
)

export default component.exports